import React from 'react';
import { FormattedMessage } from 'react-intl';
import MaskedInput from 'react-text-mask';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { useUser } from '@/contexts/UserContext';
import { masksByCountry } from '@/helpers/mask';

const ZipcodeElement = React.forwardRef((props, ref) => {
  const me = useUser();
  const zipcodeMask = masksByCountry[me?.profile?.country || 'BR'].ZIPCODE_MASK;

  return <MaskedInput {...props} ref={ref} guide={false} mask={zipcodeMask} autoComplete="off" />;
});

ZipcodeElement.propTypes = {
  // inputRef prop is passed as ref via forwardRef
};

const ZipcodeWidget = ({ disabled, id, label, onChange, options, rawErrors, required, value }) => {
  const error = !!(rawErrors && rawErrors.length > 0);

  return (
    <div className="w-full">
      <label 
        className="inline-block text-[12px] font-bold text-[#212529] font-['Open_Sans'] mt-[0.3vh] mb-1 tracking-tight" 
        htmlFor={id}
      >
        <FormattedMessage id={label} />
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>

      <ZipcodeElement
        disabled={disabled}
        name={id}
        id={id}
        data-cy={id}
        maxLength={options?.maxlength}
        value={value || ''}
        onChange={event => onChange(event.target.value)}
        style={{ fontWeight: 'normal', color: disabled ? 'rgba(0, 0, 0, 0.38)' : '#212529' }}
        className={classNames(
          "w-full max-w-[200px] rounded-[4px] !h-[37px] !px-[12px] py-[6px] text-[14px] !font-normal font-['Open_Sans'] transition-all focus:outline-none",
          {
            "bg-white": !disabled,
            "!text-[#212529]": !disabled,
            "border-[1px] border-solid border-[#dc3545] focus:border-[#dc3545]": error,
            "border-[1px] border-solid border-[#ced4da] focus:border-[#80bdff]": !error,
            "bg-[#efefef] cursor-not-allowed text-[rgba(0,0,0,0.38)]": disabled
          }
        )}
      />

      {error && (
        <p className="order-form-field-error">
          {rawErrors[0]}
        </p>
      )}
    </div>
  );
};

ZipcodeWidget.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.object,
  rawErrors: PropTypes.array,
  required: PropTypes.bool,
  value: PropTypes.string,
};

export default ZipcodeWidget;
